import React from "react";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigation = (serviceId) => {
    sessionStorage.setItem("selectedService", serviceId); // Store clicked service
    navigate("/features"); // Redirect to features page
  };

  return (
    <div className="bg-[#FFF] w-full  pb-[17px]">
      <div className="bg-lightblack m-auto  w-[98%] pt-[107px]  relative rounded-[25px]">
        <div className="max-w-[80%] m-auto max-xxl:max-w-[90%]">
          {/* Top Section */}
          <div className="pb-[93px] flex flex-col lg:flex-row justify-between items-center lg:items-start gap-12 lg:gap-0">
            {/* Logo and Social Icons */}
            <div className="flex flex-col items-center lg:items-start">
              <div className="mb-[41px]">
                <img src="../../assets/logo-white.svg" alt="Logo" />
              </div>
              <div className="flex gap-[60px]">
                <a href="#">
                  <Icon
                    color="#F5F5F5"
                    icon="ic:baseline-facebook"
                    width={27}
                    height={27}
                  />
                </a>
                <a href="#" aria-label="Twitter">
                  <Icon
                    color="#F5F5F5"
                    icon="pajamas:twitter"
                    width={27}
                    height={27}
                  />
                </a>
                <a href="#" aria-label="LinkedIn">
                  <Icon
                    color="#F5F5F5"
                    icon="uil:linkedin"
                    width={27}
                    height={27}
                  />
                </a>
                <a href="#" aria-label="YouTube">
                  <Icon
                    color="#F5F5F5"
                    icon="mdi:youtube"
                    width={27}
                    height={27}
                  />
                </a>
              </div>
            </div>

            {/* Contacts */}
            <div className="flex flex-col items-center lg:items-start">
              <p className="large font-bold mb-[22px] leading-[24px] light-white font-manrope">
                {t("home.footer.contacts.title")}
              </p>
              <h5 className="font-semibold light-white font-manrope mb-[14px] leading-[35px]">
                {t("home.footer.contacts.number")}
              </h5>
              <a
                href="mailto:neuros@mail.co "
                className="light-white font-manrope medium font-medium"
              >
                {t("home.footer.contacts.email")}
              </a>
            </div>

            {/* Company and Services Links */}
            <div className="flex flex-col lg:flex-row gap-[96px] md:flex-row">
              {/* Company Links */}
              <div className="flex flex-col">
                <h6 className="font-semibold  mb-[12px] light-white font-manrope">
                  {t("home.footer.company.title")}
                </h6>
                <a
                  onClick={() => {
                    navigate("/about-us");
                  }}
                >
                  <p className="cursor-pointer medium light-white font-manrope leading-[30px]">
                    {t("home.footer.company.about")}
                  </p>
                </a>
                {/* <a href="#">
                  <p className="medium light-white font-manrope leading-[30px]">
                    {t("home.footer.company.expertise")}
                  </p>
                </a>
                <a href="#">
                  <p className="medium light-white font-manrope leading-[30px]">
                    {t("home.footer.company.sustainability")}
                  </p>
                </a>
                <a href="#">
                  <p className="medium light-white font-manrope leading-[30px]">
                    {t("home.footer.company.news")}
                  </p>
                </a>
                <a href="#">
                  <p className="medium light-white font-manrope leading-[30px]">
                    {t("home.footer.company.team")}
                  </p>
                </a>
                <a href="#">
                  <p className="medium light-white font-manrope leading-[30px]">
                    {t("home.footer.company.contacts")}
                  </p>
                </a> */}
              </div>

              {/* Services Links */}
              <div className="flex flex-col">
                <h6 className="font-semibold mb-[12px] light-white font-manrope">
                  {t("home.footer.services.title")}
                </h6>

                <p
                  className="medium light-white font-manrope leading-[30px] cursor-pointer"
                  onClick={() => handleNavigation(1)}
                >
                  {t("home.footer.services.one")}
                </p>

                <p
                  className="medium light-white font-manrope leading-[30px] cursor-pointer"
                  onClick={() => handleNavigation(2)}
                >
                  {t("home.footer.services.two")}
                </p>

                <p
                  className="medium light-white font-manrope leading-[30px] cursor-pointer"
                  onClick={() => handleNavigation(3)}
                >
                  {t("home.footer.services.three")}
                </p>

                <p
                  className="medium light-white font-manrope leading-[30px] cursor-pointer"
                  onClick={() => handleNavigation(4)}
                >
                  {t("home.footer.services.four")}
                </p>

                <p
                  className="medium light-white font-manrope leading-[30px] cursor-pointer"
                  onClick={() => handleNavigation(5)}
                >
                  {t("home.footer.services.five")}
                </p>

                <p
                  className="medium light-white font-manrope leading-[30px] cursor-pointer"
                  onClick={() => handleNavigation(6)}
                >
                  {t("home.footer.services.six")}
                </p>
              </div>
            </div>
          </div>
          <div className="relative w-full ">
            <img
              src="../../assets/images/home/footer-bottom.png"
              alt=""
              className="w-full m-auto "
            />
            <div className="flex justify-between max-sm:items-center max-sm:flex-col absolute top-[55%] px-[78px] w-full max-sm:px-[2px]">
              <p className="font-medium medium text-[rgba(51,51,51,0.75)] max-sm:text-center">
                {t("home.footer.copyright")}
              </p>
              <div className="flex gap-1  max-sm:hidden">
                <a href="#">
                  <p className="font-medium medium text-[rgba(51,51,51,0.75)] underline">
                    {t("home.footer.terms")}
                  </p>
                </a>
                <a href="#">
                  <p className="font-medium medium text-[rgba(51,51,51,0.75)] underline">
                    {t("home.footer.privacy")}
                  </p>
                </a>
                <a href="#">
                  <p className="font-medium medium text-[rgba(51,51,51,0.75)]">
                    {t("home.footer.policy")}
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
